import { Component, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup} from '@angular/forms';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { MatLegacyTable as MatTable, MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { FirmenstandorteService } from '@app/services/firmenstandorte.service';
import { SearchResultDto } from '@app/dto/search.result.dto';
import { forkJoin, map, Observable } from 'rxjs';
import { FirmenstandorteIndexFirmenstandortDto } from '@app/dto/firmenstandorte.index.firmenstandort.dto';
import { FirmenstandorteIndexResponseDto } from '@app/dto/firmenstandorte.index.response.dto';
import { TableElement } from '@app/dto/table.element.model';
import { expandableRowAnimation } from './expandable-row.animation';
import { FirmenstandortTransactionDto } from '@app/dto/firmenstandort.transaction.dto';

@Component({
  selector: 'app-search',
  templateUrl: './firmen.component.html',
  styleUrls: ['./firmen.component.scss'],
  animations: [expandableRowAnimation],
})
export class FirmenComponent {

  public firmenSearchForm: FormGroup = new FormGroup({
    firma:          new FormControl(''),
    firmenstandort: new FormControl('')
  });
  public resultDataSource: any;
  public initColumns = [
    {
      name: 'firmenname',
      label: 'Name',
      type: 'firma-column',
      isFiltered: false,
    },
    {
      name: 'firmenId',
      label: 'Firmen-ID',
      type: 'firma-column',
      isFiltered: false,
    },
    {
      name: 'crefonummer',
      label: 'Crefonummer',
      type: 'firma-column',
      isFiltered: false,
    },
    {
      name: 'strasseUndHausnummer',
      label: 'Straße',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
    {
      name: 'plz',
      label: 'PLZ',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
    {
      name: 'ort',
      label: 'Ort',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
    {
      name: 'laenderCode',
      label: 'Land',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
    {
      name: 'beDirectId',
      label: 'BeDirect-ID',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
    {
      name: 'firmenstandorteId',
      label: 'Firmenstandorte-ID',
      type: 'firmenstandort-column',
      isFiltered: false,
    },
  ];
  public displayedColumns = this.initColumns.map(col => col.name);
  public resultListLength: number  = 0;
  public currentPage: number       = 0;
  public pageSize: number          = 10;
  public  showAlsoDeletedElements: boolean    = false;

  @ViewChildren('innerTables') innerTables = new QueryList<MatTable<FirmenstandortTransactionDto>>();

  private  firmaFieldsString: string           = 'firmenname,firmenId,crefonummer,firmenstandorteId';
  private  firmenstandortFieldsString: string  = 'strasseUndHausnummer,plz,ort,beDirectId';
  private filterString: string                = 'istGeloescht eq false';
  private firmaOrderByString: string          = 'orderColSuche,plz'; // default asc
  private firmenstandortOrderByString: string = 'plz,orderColSuche'; // default asc

  private useExactSearchFirma: boolean        = true;
  private searchSpecialCharacterFirma: string = this.useExactSearchFirma ? '*' : '~';
  private searchModeFirma: string             = this.useExactSearchFirma ? 'all' : 'any';
  private queryTypeFirma: string              = this.useExactSearchFirma ? 'simple' : 'full';

  private useExactSearchFirmenstandort: boolean         = true;
  private searchSpecialCharacterFirmenstandort: string  = this.useExactSearchFirmenstandort ? '*' : '~';
  private searchModeFirmenstandort: string              = this.useExactSearchFirmenstandort ? 'all' : 'any';
  private queryTypeFirmenstandort: string               = this.useExactSearchFirmenstandort ? 'simple' : 'full';


  constructor(
    private firmenstandorteService: FirmenstandorteService,
    private router: Router
  ) {

    const combinedSearchStringsLocal = localStorage.getItem('combinedSearchStrings') ?? '';
    if (combinedSearchStringsLocal) {
      const searchStringsLocalObj = JSON.parse(combinedSearchStringsLocal);
      if (searchStringsLocalObj) {
        let combinedSearchStrings = {
          firma:          searchStringsLocalObj.firma           ?? '',
          firmenstandort: searchStringsLocalObj.firmenstandort  ?? ''
        };

        this.firmenSearchForm.setValue(combinedSearchStrings);
      }
      this.search(0);
    }
  }

  private getCombinedFirmaSearchStrings() {
    return {
      'firma':          this.firmenSearchForm.controls['firma']?.value,
      'firmenstandort': this.firmenSearchForm.controls['firmenstandort']?.value
    }
  }

  private findFirmenstandorte(search: string, searchFields: string, searchMode: string, queryType: string, orderby: string, skip: number): Observable<FirmenstandorteIndexResponseDto> {
    return this.firmenstandorteService.getFirmenstandorte(
      `${search}${this.searchSpecialCharacterFirma}`,
      searchFields,
      searchMode,
      queryType,
      orderby,
      this.pageSize,
      skip,
      true,
      this.filterString
    );
  }

  public search(skip: number) {
    let resultList: TableElement[] = [];

    let firmaSearchString          = '';
    let firmenstandortSearchString = '';

    const combinedSearchStrings = this.getCombinedFirmaSearchStrings();
    if (combinedSearchStrings) {
      firmaSearchString          = combinedSearchStrings.firma;
      firmenstandortSearchString = combinedSearchStrings.firmenstandort;

      localStorage.setItem('combinedSearchStrings', JSON.stringify(combinedSearchStrings));
    }

    let observableResponse = new Observable<FirmenstandorteIndexResponseDto>();

    if (firmaSearchString && ! firmenstandortSearchString) {
      observableResponse = this.findFirmenstandorte(firmaSearchString, this.firmaFieldsString, this.searchModeFirma, this.queryTypeFirma, this.firmaOrderByString, skip)

    } else if ( ! firmaSearchString && firmenstandortSearchString) {
      observableResponse = this.findFirmenstandorte(firmenstandortSearchString, this.firmenstandortFieldsString, this.searchModeFirmenstandort, this.queryTypeFirmenstandort, this.firmenstandortOrderByString, skip)

    } else if (firmaSearchString && firmenstandortSearchString) {
      this.pageSize = 20;
      observableResponse = forkJoin([
        this.findFirmenstandorte(firmaSearchString, this.firmaFieldsString, this.searchModeFirma, this.queryTypeFirma, this.firmaOrderByString, skip),
        this.findFirmenstandorte(firmenstandortSearchString, this.firmenstandortFieldsString, this.searchModeFirmenstandort, this.queryTypeFirmenstandort, this.firmenstandortOrderByString, skip),
      ]).pipe(
          map(([a, b]) => {
            return {
              '@odata.count': a['@odata.count'] + b['@odata.count'],
              value: a.value.concat(b.value),
            }
          })
      )
    }

    observableResponse.pipe(
      map(result => {
        this.resultListLength = result['@odata.count'];
        return result.value;
      }),
    ).subscribe(response => {
        if (response) {
          response.forEach((firmenstandort: FirmenstandorteIndexFirmenstandortDto) => {
            let result: TableElement = {
              ...firmenstandort,
            };
            resultList.push(result);
          });
        }
        this.resultDataSource = new MatTableDataSource(resultList);
      });
  }

  public updateResultList() {
    this.showAlsoDeletedElements = !this.showAlsoDeletedElements;
    if (this.showAlsoDeletedElements) {
      this.filterString = 'istGeloescht eq false or istGeloescht eq true'
    } else {
      this.filterString = 'istGeloescht eq false'
    }
    this.search(0);
  }

  public getPageData(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.search(event.pageIndex * this.pageSize);
  }

  public removeFilters() {
    localStorage.removeItem('combinedSearchStrings');
    window.location.reload();
  }
  public goToFirma(data: SearchResultDto) {
    return this.router.navigate([`firma/${data.firmenId}`]);
  }

  public filterField(fieldName: string, columnType: string, filterValue: string) {

      if (filterValue) {
        this.initColumns.filter(column => column.name == fieldName).forEach(column => column.isFiltered = true);
        let searchSpecialCharacter = columnType == 'firma-column' ? this.searchSpecialCharacterFirma : this.searchSpecialCharacterFirmenstandort;
        this.filterString = `${this.filterString} and search.ismatch('${filterValue}${searchSpecialCharacter}', '${fieldName}', 'full', 'any')`;
        this.currentPage = 0;
        this.search(0);
      }
  }

  public removeColumnFilter(columnName: string) {
    this.filterString = this.filterString.split("and")?.filter(element => element.indexOf(columnName) == -1).join("and");
    this.initColumns.filter(column => column.name == columnName)[0].isFiltered = false;
    this.currentPage = 0;
    this.search(0);
  }
}
